<template>
  <div
    class="min-h-screen flex items-center justify-center bg-ds-bckgnd-color p-6"
  >
    <div
      class="w-full max-w-md bg-white rounded-2xl shadow-2xl overflow-hidden"
    >
      <div class="bg-header-bg-color px-6 py-5">
        <h2 class="text-2xl font-bold text-white text-center tracking-tight">
          IWC Agent Management System
        </h2>
        <p class="text-sm text-gray-100 text-center mt-1">
          Secure access to your account
        </p>
      </div>
      <form @submit.prevent="submitHandler" class="px-8 py-8 space-y-6">
        <div>
          <label class="block text-sm font-medium text-txt-primary-color mb-2">
            Username
          </label>
          <input
            v-model="formData.username"
            type="text"
            placeholder="Enter your username"
            class="w-full px-4 py-3 border border-brd-primary-color rounded-xl shadow-sm focus:ring-2 focus:ring-ds-button-color focus:outline-none"
          />
        </div>
        <div>
          <label class="block text-sm font-medium text-txt-primary-color mb-2">
            Password
          </label>
          <input
            v-model="formData.password"
            type="password"
            placeholder="Enter your password"
            class="w-full px-4 py-3 border border-brd-primary-color rounded-xl shadow-sm focus:ring-2 focus:ring-ds-button-color focus:outline-none"
          />
        </div>
        <div class="flex items-center justify-between">
          <label class="flex items-center space-x-2 text-sm text-gray-600">
            <input
              type="checkbox"
              v-model="formData.remember"
              class="rounded border-gray-300 focus:ring-ds-button-color"
            />
            <span>Remember me</span>
          </label>
        </div>
        <button
          type="submit"
          class="w-full rounded-xl bg-ds-button-color px-4 py-3 font-semibold text-white shadow-md transition hover:scale-105 active:scale-95"
          :disabled="isLoading"
        >
          {{ isLoading ? "Signing in..." : "Sign In" }}
        </button>
        <p v-if="isAlertPopUp" class="text-red-600 text-sm text-center mt-2">
          {{ isAlertPopUpMessage }}
        </p>
      </form>
      <div
        class="bg-gray-50 border-t border-gray-200 py-4 text-center text-sm text-gray-500"
      >
        © 2025 IMS Wellth Care, Inc. All rights reserved.
      </div>
    </div>
  </div>
</template>

<script>
import { toRefs, reactive, inject, ref } from "vue";
export default {
  setup() {
    const axios = inject("$axios");
    const router = inject("$router");
    const store = inject("$store");
    const isAlertPopUp = ref(false);
    const isAlertPopUpMessage = ref(null);
    const isLoading = ref(false);
    const formData = reactive({
      username: "",
      password: "",
    });

    const submitHandler = async () => {
      isLoading.value = true;
      isAlertPopUp.value = false;
      try {
        const response = await axios.post("/wb/agent/portal/login", formData);
        if (response.status === 201) {
          const { data: authData, token } = response.data;
          store.commit("getAdminLogDetails", authData);
          const authTokenKey = `${process.env.VUE_APP_AUTH_TOKEN}_XXX`;
          localStorage.setItem(authTokenKey, token);
          router.push("/dashboard");
        } else {
          isAlertPopUp.value = true;
          isAlertPopUpMessage.value = response.data.message || "Login failed.";
        }
      } catch (error) {
        store.commit("errorHandler", error);
      } finally {
        isLoading.value = false;
      }
    };

    return {
      ...toRefs(formData),
      formData,
      submitHandler,
      isAlertPopUp,
      isAlertPopUpMessage,
      isLoading,
    };
  },
};
</script>
